import { addTaskOnFirstGroup, setDynamicModalObj } from '../../store/board.actions';
import { useRef, useState, useEffect } from 'react';
import { utilService } from '../../services/util.service';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FaAngleDown } from 'react-icons/fa';
import { BsPersonCircle } from 'react-icons/bs';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';
import { useParams } from "react-router-dom";
import { userService } from '../../services/user.service';
import { GeneralQueryActions } from "../../store/grupo.actions";
import { ROLES } from '../../services/user.service';
import { setDynamicModalObj2 } from "../../store/grupo.actions";
import { Button } from '@mui/material';
import FilterModal from './../modal/advanced_filter_modal'; // Importa tu modal
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

export function BoardFilter({ customHeight, setCustomHeight, board, onSetFilter }) {
    const filter = useSelector(storeState => storeState.boardModule.filter);
    const [filterBy, setFilterBy] = useState({ ...filter, memberIds: [] });
    const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj);
    const dynamicModalObj2 = useSelector(storeState => storeState.grupoModule.dynamicModalObj);

    const elBoardFilter = useRef();
    const elMemberFilter = useRef();
    const [user, setUser] = useState(userService.getLoggedinUser().data.data);
    const { boardId } = useParams();
    const members = useSelector(storeState => storeState.userModule.users);
    const isEditable = user.rol === ROLES.ADMIN || user.rol === ROLES.AUDITOR;
    const isEditablefilter = user.rol === ROLES.ADMIN;
    const [shouldFetch, setShouldFetch] = useState(false);  // Estado para controlar la ejecución de la consulta

    const showResponsableTitle = !filterBy.memberIds.length;
    const UsuariosA = 'grupos/actividades';
    const parametrosA = { idTablero: boardId };
    const UsuariosT = 'grupos/getGruposWithUsuarios';
    const parametrosT = { idTablero: boardId, idUsuario: user.id_usuario };

    const debouncedSetFilter = useRef(utilService.debounce(onSetFilter)).current;

    useEffect(() => {
        debouncedSetFilter(filterBy);

        if (shouldFetch && filterBy.memberIds.length === 0) {  // Verifica si debe ejecutar la consulta
            if (isEditable) {
                GeneralQueryActions(UsuariosA, parametrosA);  
            } else {
                GeneralQueryActions(UsuariosT, parametrosT);
            }
            setShouldFetch(false);  // Reinicia el estado para evitar consultas repetidas
        }
    }, [filterBy, debouncedSetFilter, shouldFetch,isEditable]);

    function handleChange({ target }) {
        let { value, name: field } = target;
        setFilterBy((prevFilter) => ({ ...prevFilter, [field]: value }));
    }

    function onRemovePersonFilter(ev) {
        ev.stopPropagation();
        setFilterBy(prevFilter => ({ ...prevFilter, memberIds: [] }));
        setShouldFetch(true);  // Actualiza el estado para permitir la ejecución de la consulta
    }

    function onToggleMenuModal() {
        const isOpen = dynamicModalObj2?.type === 'add-group' ? !dynamicModalObj2.isOpen : true;
        const { x, y, height } = elBoardFilter.current.getClientRects()[0];
        setDynamicModalObj2({ isOpen, pos: { x: (x + 60), y: (y + height) }, type: 'add-group' });
    }

    function onToggleMemberFilterModal() {
        const isOpen = dynamicModalObj?.type === 'member-filter' ? !dynamicModalObj.isOpen : true;
        const { x, y } = elMemberFilter.current.getClientRects()[0];
        setDynamicModalObj({ isOpen, pos: { x: (x - 160), y: (y + 40) }, type: 'member-filter', filterBy, setFilterBy });
    }

    function isMemberModalOpen() {
        return dynamicModalObj.isOpen && dynamicModalObj.type === 'member-filter';
    }

    const handleChangeSelect = (event) => {
        setCustomHeight(event.target.value);
    };

    const selectedMembers = members.filter(member => filterBy.memberIds.includes(member.id_usuario));

    //Parte de los nuevos filtros avanzados 

    const [openModal, setOpenModal] = useState(false);

    // Función para abrir el modal
    const handleOpenModal = () => {
      setOpenModal(true);
    };
  
    // Función para cerrar el modal
    const handleCloseModal = () => {
      setOpenModal(false);
    };
  

    return (
        <section ref={elBoardFilter} className="board-filter flex align-center">
            {isEditablefilter && (
            <Tooltip title="Añadir nuevo Grupo" arrow>
                <div className="add-btn">
                    <span className='new-task-btn' onClick={onToggleMenuModal}>Nuevo Grupo</span>
                    <div className='drop-down-btn'>
                        <FaAngleDown className="icon" />
                    </div>
                </div>
            </Tooltip>


            //             <Tooltip title="Add new task" arrow>
            //     <div className="add-btn">
            //         <span className='new-task-btn' onClick={onToggleMenuModal}>Nueva Tarea</span>
            //         <div className='drop-down-btn' >
            //             <FaAngleDown className="icon" />
            //         </div>
            //     </div>
            // </Tooltip> 
             )}
            <div className='board-tools flex align-center'>
            
                <div className='search-task' style={{ marginLeft: "10px",marginRight: "10px" }}>
                    <Select
                        id="demo-simple-select"
                        value={customHeight}
                        onChange={handleChangeSelect}
                        variant='standard'
                        size='small'
                    >
                        <MenuItem value={60}>Esp. Sencillo</MenuItem>
                        <MenuItem value={80}>Esp. Doble</MenuItem>
                        <MenuItem value={140}>Esp. Triple</MenuItem>
                    </Select>
                </div>
                

                {isEditable && (
                    <Tooltip title="Filtro por Responsable" arrow>
                        <div
                            ref={elMemberFilter}
                            onClick={onToggleMemberFilterModal}
                            className={`person-filter ${(isMemberModalOpen() || filterBy.memberIds.length) ? ' active' : ''}`}
                        >
                            <BsPersonCircle className='icon' />
                            {showResponsableTitle && <span>Responsable</span>}
                            {filterBy.memberIds.length > 0 && (
                                <>
                                    {selectedMembers.slice(0, 2).map(member => (
                                        <img key={member.id_usuario} src={member.imgurl} alt={member.primer_nombre} className="selected-member-img" />
                                    ))}
                                    {selectedMembers.length > 2 && (
                                        <div className='show-more-members'>
                                            <span className='show-more-count'>+{selectedMembers.length - 2}</span>
                                        </div>
                                    )}
                                    <AiFillCloseCircle onClick={onRemovePersonFilter} />
                                </>
                            )}
                        </div>
                    </Tooltip>
                    
                )}
                 {isEditable && (
                    <div className='board-tools flex align-center'>
                     <Tooltip title="Filtro avanzado de actividades " arrow>
                    <div 
                        onClick={handleOpenModal}  style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', }}>
                        {/* Ícono de filtro */}
                        <FilterAltIcon style={{ marginRight: '2px' }} />  

                        {/* Texto al lado del ícono */}
                        <span style={{ color: '#9c9a9a' }}>
                            Filtrar Datos
                        </span>
                    </div>
                    </Tooltip>

                    {/* Modal que se abre cuando el estado `openModal` es true */}
                    <FilterModal open={openModal} handleClose={handleCloseModal} />
                    </div>
                    
                )}

               



            </div>
        </section>
    );
}

